export default {
  signUp: 'signUp',
  login: 'login',
  logout: 'logout',
  calculator: 'calculator',
  budget: 'budget',
  carSearch: 'carSearch',
  carSearchVariant: 'carSearchVariant',
  quoteUpload: 'quoteUpload',
  carColourAndExtras: 'carColourAndExtras',
  dealerPrice: 'dealerPrice',
  summary: 'summary',
  hrApproval: 'hrApproval',
  hrApprovalSent: 'hrApprovalSent',
  vehicleOrdered: 'vehicleOrdered',
  redirection: 'redirection',
  quoteNotFound: 'quoteNotFound'
};
